export default function FormGroup() {
    return {
        MuiFormGroup: {
            styleOverrides: {
                root: {
                    alignItems: "flex-start",
                },
            },
        },
    };
}
